import { RouteConfig } from 'vue-router';
import MswSpogLogin from './msw-spog-login.vue';

export const route: RouteConfig = {
  path: 'login',
  component: MswSpogLogin,
};

export function getDefaultParams() {
  return {};
}

// export default route;
